<template>
    <div class="main report">

        <div class="report-heading">
            <h1><span class="breadcrumb" @click="clearFilters()">Distributor Movement</span><i v-if="distributor_name" class="fas fa-chevron-right"></i><span class="breadcrumb" @click="clearItems()">{{ distributor_name }}</span></h1>
            <div v-if="notEmpty(totals)" class="report-total" style="grid-template-columns: 1fr 1fr 1fr;">
                <div>
                    <label>Total Items Moved</label><br>{{ formatNumber(totals.moved) }}
                </div>
                <div>
                    <label>Total Moved Cost</label><br>{{ formatCurrency(totals.cost_moved) }}
                </div>
                <div>
                    <label>Total On Hand Cost</label><br>{{ formatCurrency(totals.cost_on_hand) }}
                </div>
            </div>
        </div>

        <div class="filters with-compare">
            <div v-if="filters.department_id" class="three-columns selectors">
                <label>Manufacturer</label>
                <label>UPC / SKU</label>
                <label></label>
                <div class="input-with-control">
                    <input class="distributors" type="text" v-model="filters.manufacturer_name" placeholder="Search..." @keyup.enter="setFilter('manufacturer')">
                    <div class="button distributors input-go" @click="setFilter('manufacturer')"><i class="fas fa-search"></i></div>
                    <div v-if="manufacturerSearchList.length > 0 || manufactuerSearchMessage" class="search-list">
                        <div v-for="manufacturer in manufacturerSearchList" class="search-list-item" :key="manufacturer.manufacturer_id" @click="setFilterFromSearch(manufacturer)">{{ manufacturer.description }}</div>
                        <div v-if="manufactuerSearchMessage">{{ manufactuerSearchMessage }}</div>
                    </div>
                </div>
                <div class="input-with-control">
                    <input class="distributors" type="text" v-model="filters.search_text" placeholder="Search..." @keyup.enter="setFilter('search_text')">
                    <div class="button distributors input-go" @click="setFilter('search_text')"><i class="fas fa-search"></i></div>
                </div>
            </div>
            <div v-else></div>
            <div>
                <div class="input-with-control date-control">
                    <label>Start</label>
                    <label>End</label>
                    <label></label>
                    <input class="distributors" type="date" :min="minFilterDate" :max="maxFilterDate" v-model="filters.start_date" required="required">
                    <input class="distributors" type="date" :min="minFilterDate" :max="maxFilterDate" v-model="filters.end_date" required="required">
                    <div class="button distributors input-go" @click="setFilterDates()"><i class="fas fa-calendar-check"></i></div>
                </div>
            </div>
            <div>
                <div class="button distributors compare-button" @click="showCompare = true"><i class="fas fa-calendar-plus"></i></div>
            </div>
        </div>

        <div v-if="message" class="empty-list">
            {{ message }}
            <div v-if="loading" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
        </div>

        <div v-if="distributors.length > 0 && !loading" class="report-list distributors">
            <div class="report-row heading">
                <h2>Distributor</h2>
                <label></label>
                <label class="right">SKU Count</label>
                <label class="right">On Hand SKUs</label>
                <label class="right" @click="setSort('sku_percent_in_stock')">% In Stock</label>
                <label class="right">Cost On Hand</label>
                <label class="right">Qty Moved</label>
                <label class="right">Moved Cost</label>
                <label class="right">Store Received</label>
                <label class="right">Received Cost</label>
                <label class="right">Received Price</label>
            </div>
            <div class="report-row" v-for="(data, index) in distributors" :key="index">
                <div><span class="row-title">{{ data.company_name }}</span></div>
                <div><div class="button distributors" @click="getListDepartments(data)"><i class="fas fa-list"></i></div></div>
                <div><span class="numbers full">{{ data.sku_count || 0 }}</span></div>
                <div><span class="numbers full">{{ data.sku_on_hand_count || 0 }}</span></div>
                <div><span class="numbers full">{{ data.sku_percent_in_stock || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(data.cost_on_hand) || 0 }}</span></div>
                <div><span class="numbers full">{{ data.moved || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(data.cost_moved) || 0 }}</span></div>
                <div><span class="numbers full">{{ data.received || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(data.cost_received) || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(data.price_received) || 0 }}</span></div>
            </div>

            <div class="report-row">
                <div><span class="row-title">All Distributors</span></div>
                <div></div>
                <div><span class="numbers full">{{ totals.sku_count || 0 }}</span></div>
                <div><span class="numbers full">{{ totals.sku_on_hand_count || 0 }}</span></div>
                <div><span class="numbers full">{{ totals.sku_percent_in_stock || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(totals.cost_on_hand) || 0 }}</span></div>
                <div><span class="numbers full">{{ totals.moved || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(totals.cost_moved) || 0 }}</span></div>
                <div><span class="numbers full">{{ totals.received || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(totals.cost_received) || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(totals.price_received) || 0 }}</span></div>
            </div>

        </div>

        <div v-if="Object.keys(department_set).length > 0 && !loading" class="report-list distributors">
            <div v-for="(list, section) in department_set" :key="section" class="report-list department">
                <div v-if="list.length > 0" class="report-row heading">
                    <h2>{{ sectionTitle(section) }}</h2>
                    <label></label>
                    <label class="right">SKU Count</label>
                    <label class="right">On Hand SKUs</label>
                    <label class="right">% In Stock</label>
                    <label class="right">Cost On Hand</label>
                    <label class="right">Qty Moved</label>
                    <label class="right">Moved Cost</label>
                    <label class="right">Store Received</label>
                    <label class="right">Received Cost</label>
                    <label class="right">Received Price</label>
                </div>
                <div class="report-row" v-for="(data, index) in list" :key="index">
                    <div><span class="row-title">{{ data.description }}</span></div>
                    <div><div class="button distributors" @click="getListItems(data)"><i class="fas fa-list"></i></div></div>
                    <div><span class="numbers full">{{ data.sku_count || 0 }}</span></div>
                    <div><span class="numbers full">{{ data.sku_on_hand_count || 0 }}</span></div>
                    <div><span class="numbers full">{{ data.sku_percent_in_stock || 0 }}</span></div>
                    <div><span class="numbers full">{{ formatCurrency(data.cost_on_hand) || 0 }}</span></div>
                    <div><span class="numbers full">{{ data.moved || 0 }}</span></div>
                    <div><span class="numbers full">{{ formatCurrency(data.cost_moved) || 0 }}</span></div>
                    <div><span class="numbers full">{{ data.received || 0 }}</span></div>
                    <div><span class="numbers full">{{ formatCurrency(data.cost_received) || 0 }}</span></div>
                    <div><span class="numbers full">{{ formatCurrency(data.price_received) || 0 }}</span></div>
                </div>
            </div>
        </div>

        <div v-if="items.length > 0 && !loading" class="report-list">
            <div class="report-row distributor-items heading">
                <h2>{{ department_name }}</h2>
                <label></label>
                <label :class="['right', 'sortable', { sortcurrent: filters.sort_column == 'on_hand' }]" @click="setSort('on_hand')">On Hand <i v-if="filters.sort_column == 'on_hand'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                <label :class="['right', 'sortable', { sortcurrent: filters.sort_column == 'cost_on_hand' }]" @click="setSort('cost_on_hand')">On Hand Cost <i v-if="filters.sort_column == 'cost_on_hand'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                <label :class="['right', 'sortable', { sortcurrent: filters.sort_column == 'moved' }]" @click="setSort('moved')">Qty Moved <i v-if="filters.sort_column == 'moved'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                <label :class="['right', 'sortable', { sortcurrent: filters.sort_column == 'cost_moved' }]" @click="setSort('cost_moved')">Moved Cost <i v-if="filters.sort_column == 'cost_moved'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                <label :class="['right', 'sortable', { sortcurrent: filters.sort_column == 'received' }]" @click="setSort('received')">Store Received <i v-if="filters.sort_column == 'received'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                <label :class="['right', 'sortable', { sortcurrent: filters.sort_column == 'cost_received' }]" @click="setSort('cost_received')">Received Cost <i v-if="filters.sort_column == 'cost_received'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                <label :class="['right', 'sortable', { sortcurrent: filters.sort_column == 'price_received' }]" @click="setSort('price_received')">Received Price <i v-if="filters.sort_column == 'price_received'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
            </div>
            <div class="report-row distributor-items" v-for="(data, index) in items" :key="index">
                <div>
                    <div class="row-title">{{ data.description }}</div>
                    <label style="width: auto; padding: 0 1em 0 0;">UPC</label>{{ data.upc }}
                    <label style="width: auto; padding: 0 1em 0 2em;">Item</label>{{ data.item_number }}
                </div>
                <div><div class="button distributors" @click="getItem(data)"><i class="fas fa-list"></i></div></div>
                <div><span class="numbers full">{{ data.on_hand || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(data.cost_on_hand) || 0 }}</span></div>
                <div><span class="numbers full">{{ data.moved || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(data.cost_moved) || 0 }}</span></div>
                <div><span class="numbers full">{{ data.received || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(data.cost_received) || 0 }}</span></div>
                <div><span class="numbers full">{{ formatCurrency(data.price_received) || 0 }}</span></div>
            </div>
        </div>

        <pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>

        <compare-dates :active="showCompare" :section="'distributors'" @cancel="showCompare = false" />

    </div>
</template>
<script>
export default {
    name: 'distributors',
    props: ['distributor_id', 'department_id'],
    data() {
        return {
            loading: true,
            message: '',
            filters: {
                section: 'distributors',
                start_date: '',
                end_date: '',
                distributor_id: '',
                department_id: '',
                search_text: '',
                location_id: '',
                location_name: '',
                filter_by_list: '',
                sort_column: 'cost_moved',
                sort_descending: true
            },
            distributors: [],
            totals: {},
            paging: {},
            departments: [],
            department_set: [],
            items: [],
            distributor_name: '',
            department_name: '',
            manufacturerSearchList: [],
            manufactuerSearchMessage: '',
            itemSearchList: [],
            itemSearchMessage: '',
            dealerSearchList: [],
            dealerSearchMessage: '',
            minFilterDate: '',
            maxFilterDate: '',
            showCompare: false
        }
    },
    created() {
        this.filters.start_date = this.getQueryString('start') || this.getYearStartDate()
        this.filters.end_date = this.getQueryString('end') || this.getYesterdaysDate()
        this.minFilterDate = this.filters.start_date.split('-').shift() + '-01-01'
        this.maxFilterDate = this.filters.end_date.split('-').shift() + '-12-31'
        // any filters previously stored for this section?
        if (this.getFilters.section == 'distributors') {
            this.filters = this.getFilters // filters were stored last time we hit fetchDataItems()
        }
        if (this.department_id) {
            this.filters.distributor_id = this.distributor_id
            this.filters.department_id = this.department_id
            this.fetchItems()
        } else if (this.distributor_id) {
            this.filters.distributor_id = this.distributor_id
            this.fetchData()
        } else {
            this.filters.distributor_id = ''
            this.fetchData()
        }
    },
    computed: {
        showPagination() {
            return this.distributor_id && this.items.length > 0 && this.paging.total_pages > 1
        }
    },
    methods: {
		fetchData() {
            this.totals = {}
            this.distributors = []
            this.departments = []
            this.department_sets = {}
            this.loading = true
            this.message = 'Loading'
            this.storeFilters({}) // clear all stored filters
            this.apiCall({ destination: 'get_report_distributors', data: this.filters }).then(obj => {
                this.loading = false
                if (obj.status == 'success') {
                    this.storeFilters(this.filters) // store current filter set
                    if (obj.distributors) {
                        this.distributors = obj.distributors
                    }
                    if (obj.department_set) {
                        this.department_set = obj.department_set
                    }
                    if (obj.distributor_name) {
                        this.distributor_name = obj.distributor_name
                    }
                    this.paging = obj.paging
                    this.totals = obj.totals
                    this.loading = false
                    this.message = ''
                    window.scrollTo(0,0);
                } else {
                    this.message = obj.message
                }
            })
        },
        setFilterDates() {
            this.$router.push({ path: this.$route.path , query: { start: this.filters.start_date, end: this.filters.end_date } })
        },
        goToPage(page) {
			this.paging.current_page = page
			this.setFilter('page')
		},
        setSort(which) {
            //only sort if we're not already loading
            if (this.loading) { return }
            if (this.filters.sort_column == which) {
                this.filters.sort_descending = !this.filters.sort_descending
            } else {
                this.filters.sort_column = which
            }
            if (this.filters.distributor_id) {
                this.fetchItems()
            } else {
                this.fetchData()
            }
        },
        setFilter(which) {
            switch (which) {
                case 'page':
                    this.filters.page = this.paging.current_page
                    this.fetchItems()
                    return false;
                case 'manufacturer':
                    this.manufacturerSearchList = []
                    this.manufactuerSearchMessage = ''
                    this.searchFilter('manufacturer')
                    return false
                case 'search_text':
                    this.fetchItems()
                    return false
                case 'location':
                    this.dealerSearchMessage = 'Dealer search coming soon'
                    setTimeout(() => { this.dealerSearchMessage = '' }, 2000)
                    //this.searchFilter('location')
                    return false
            }
        },
        searchFilter(which) {
            this.filters.filter_by_list = which
            this.apiCall({ destination: 'get_filter_list', data: this.filters }).then(obj => {
                if (obj.status == 'success') {
                    if (obj.filter_list.length == 1) {
                        this.filters.manufacturer_name = obj.filter_list[0]['description']
                        this.filters.manufacturer_id = obj.filter_list[0]['manufacturer_id']
                        this.fetchItems()
                    } else if (obj.filter_list.length > 1) {
                        this.manufacturerSearchList = obj.filter_list
                    } else {
                        this.manufactuerSearchMessage = 'Manufacturer not found'
                    }
                } else {
                    this.message = obj.message
                }
            })
        },
        setFilterFromSearch(data) {
            if (this.filters.filter_by_list == 'manufacturer') {
                this.manufacturerSearchList = []
                this.manufactuerSearchMessage = ''
                this.filters.manufacturer_name = data.description
                this.filters.manufacturer_id = data['manufacturer_id']
            }
            this.message = ''
            this.fetchItems()
        },
        clearFilters() {
            this.filters = {
                section: 'distributors',
                start_date: '',
                end_date: '',
                distributor_id: '',
                search_text: '',
                location_id: '',
                location_name: '',
                filter_by_list: '',
            }
            this.filters.start_date = this.getQueryString('start') || this.getYearStartDate()
            this.filters.end_date = this.getQueryString('end') || this.getYesterdaysDate()
            this.items = []
            this.distributor_name = ''
            this.message = ''
            if (this.$route.path != '/distributors') {
                // pushing route will clear id
                this.$router.push({path: '/distributors', query: this.$route.query})
            } else {
                // but if base route already, reload data
                this.fetchData()
            }
        },
        clearItems() {
            if (this.$route.path != '/distributors/' + this.distributor_id) {
                this.$router.push('/distributors/' + this.distributor_id)
            }
        },
        getListDepartments(data) {
            this.filters.distributor_id = data.distributor_id
            this.distributor_name = data.description
            this.$router.push('/distributors/' + data.distributor_id)
        },
        sectionTitle(section) {
            switch (section) {
                case 'firearms':
                    return 'Firearms'
                case 'non_firearms':
                    return 'Accessories'
                case 'items':
                    return this.department_name
            }
        },
        getListItems(data) {
            this.filters.distributor_id = data.distributor_id
            this.filters.department_id = data.department_id
            this.$router.push({path: '/distributors/' + this.distributor_id + '/department/' + data.department_id, query: this.$route.query})
        },
        getItem(data) {
            this.$router.push({path: '/item/distributors/' + data.product_id, query: this.$route.query})
        },
        fetchItems() {
            this.totals = {}
            this.distributors = []
            this.items = []
            this.loading = true
            this.message = 'Loading'
            this.storeFilters(this.filters) // store current filter set
            this.apiCall({ destination: 'get_report_distributor_items', data: this.filters }).then(obj => {
                this.loading = false
                window.scrollTo(0,0);
                if (obj.status == 'success') {
                    this.distributors = []
                    if (obj.distributor_name) {
                        this.distributor_name = obj.distributor_name
                    }
                    if (obj.department_name) {
                        this.department_name = obj.department_name;
                    }
                    this.items = obj.items
                    this.totals = this.getTotals
                    this.paging = obj.paging
                    this.message = ''
                } else {
                    this.message = obj.message
                }
            })
        },
        itemMovement(data) {
            let difference = Number(data.start_quantity) - Number(data.quantity)
            return Math.abs(difference) + (difference < 0 ? " <i class='fas fa-caret-up green'></i>" : " <i class='fas fa-caret-down red'></i>")
        },
        costMovement(data) {
            let difference = (Number(data.start_cost) - Number(data.cost)).toFixed(2)
            return this.formatCurrency(Math.abs(difference)) + (difference < 0 ? " <i class='fas fa-caret-up green'></i>" : " <i class='fas fa-caret-down red'></i>")
        },
        percentOfTotal(data) {
            return ((Number(data.cost) / this.totals.cost) * 100).toFixed(1)
        },
        averageItemPrice(data) {
            return this.formatCurrency(Number(data.cost) / Number(data.quantity))
        }
    }
}
</script>
<style lang="scss" scoped>
.report-row {
    grid-template-columns: 2.5fr 0.5fr 0.75fr 0.75fr 0.75fr 1fr 0.75fr 1fr 0.75fr 1fr 1fr;
}
.distributor-items {
    grid-template-columns: 3.5fr 0.5fr 0.75fr 1fr 0.75fr 1fr 0.75fr 1fr 1fr;
}
.row-controls {
    grid-template-columns: 3fr 1fr;
    label { width: auto; padding: 0 0.5em 0 0.5em; }
}
</style>
